export type Choice = 'red' | 'blue';

export interface VoteCounts {
  red: number;
  blue: number;
  total: number;
}

export interface VoteResult {
  blueWins: boolean;
  survives: boolean;
  points: number;
}

export function getUtcRoundId(date = new Date()): string {
  return date.toISOString().slice(0, 10);
}

export function normalizeCounts(counts: Partial<VoteCounts>): VoteCounts {
  const red = Math.max(0, Math.trunc(counts.red ?? 0));
  const blue = Math.max(0, Math.trunc(counts.blue ?? 0));
  return {
    red,
    blue,
    total: Math.max(0, Math.trunc(counts.total ?? red + blue)),
  };
}

export function calculateBlueWins(counts: VoteCounts): boolean {
  return counts.total > 0 && counts.blue / counts.total > 0.5;
}

export function calculateVoteResult(choice: Choice, counts: VoteCounts): VoteResult {
  const blueWins = calculateBlueWins(counts);
  const survives = blueWins || choice === 'red';

  let points = 0;
  if (choice === 'blue' && blueWins) points = 100;
  if (choice === 'blue' && !blueWins) points = 10;
  if (choice === 'red' && blueWins) points = 20;
  if (choice === 'red' && !blueWins) points = 60;

  return { blueWins, survives, points };
}

export function percentage(part: number, total: number): number {
  if (total <= 0) return 0;
  return Math.round((part / total) * 1000) / 10;
}

